import { MutableRefObject, useEffect, useLayoutEffect, useRef } from 'react'
import { useTheme } from '@convergence/components'
import useResizeObserver from 'use-resize-observer'
import { TinkerBoxConnectionStore } from '../stores/TinkerBoxConnectionStore'

type UseTinkerBoxConnectionArgs = {
	container: MutableRefObject<HTMLDivElement | null>
	tinkerBoxConnection: TinkerBoxConnectionStore
}
const handleResize = (tinkerBoxConnection: TinkerBoxConnectionStore) => {
	tinkerBoxConnection.resize()
}

export const useTinkerBoxConnection = ({
	container,
	tinkerBoxConnection,
}: UseTinkerBoxConnectionArgs) => {
	const { darkMode } = useTheme()
	const currentSize = useRef({ width: 0, height: 0 })

	const { width, height } = useResizeObserver<HTMLDivElement>({ ref: container })

	useLayoutEffect(() => {
		if (!container.current) return
		tinkerBoxConnection.init(container.current)
		return () => {
			tinkerBoxConnection.disconnect()
		}
	}, [container, tinkerBoxConnection])

	useEffect(() => {
		tinkerBoxConnection.setDarkMode(darkMode)
	}, [darkMode, tinkerBoxConnection])

	useEffect(() => {
		currentSize.current = { width: width || 0, height: height || 0 }
		handleResize(tinkerBoxConnection)
	}, [width, height, tinkerBoxConnection])

	return tinkerBoxConnection
}
